import { BUSCAR_PESSOA } from '../../actions/types'

const initialState = undefined

export default function reducerPessoaBaseExterna (state = {}, action = initialState) {
  switch (action.type) {
    case BUSCAR_PESSOA: {
      return action.payload.data;
    }

    default: {
      return state
    }
  }
}
